import { useEffect, useState } from 'react';
import clsx from 'clsx';
import RichText from '@quno/patient-journey/src/components/ui/ContentBlocks/RichText';
import Icon from '@quno/patient-journey/src/components/ui/Icon';
import { getRichTextMultilocale } from '@quno/onboarding/src/generator/configs/componentMapper';
import styles from './Accordion.module.scss';
import type { StringAttribute } from '@quno/onboarding/src/generator/types/generics/ModelAttributes';
import type { FormLocales } from '@quno/onboarding/src/constants/locales';
import type { Document } from '@contentful/rich-text-types';
import type { JsonRichText } from '@quno/patient-journey/types/Utilities';

export type AccordionItemProps = {
  title: string;
  // content?: Document | JsonRichText;
  content: StringAttribute;
  fontColorOverride?: string;
  backgroundColorOverwrite?: string;
  locale: FormLocales;
};

export const AccordionItem = ({
  title,
  content,
  fontColorOverride,
  backgroundColorOverwrite,
  locale,
}: AccordionItemProps): JSX.Element => {
  const [showItem, setShowItem] = useState(false);
  const [textContent, setTextContent] = useState<Document | JsonRichText>();

  useEffect(() => {
    const run = async (): Promise<void> => {
      const answer = await getRichTextMultilocale(content, locale);
      setTextContent(answer);
    };

    void run();
  }, [content, locale]);

  return (
    <div
      onClick={() => {
        setShowItem(!showItem);
      }}
      className={clsx(styles.item, styles.arrow, showItem && styles.arrowOpen)}
      style={{ backgroundColor: backgroundColorOverwrite }}
    >
      <h3 className={styles.title}>
        <span style={{ color: fontColorOverride }}>{title}</span>
        <Icon
          type="Chevron"
          color={fontColorOverride ?? '#15202B'}
          width={22}
          height={12}
        />
      </h3>
      {showItem && (
        <div className={styles.content}>
          <RichText
            fields={textContent}
            noWrapper
            style={{ color: fontColorOverride }}
          />
        </div>
      )}
    </div>
  );
};
